import script from "./Result.vue?vue&type=script&setup=true&lang=ts"
export * from "./Result.vue?vue&type=script&setup=true&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=5bd292fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd292fc"]])

export default __exports__